import { Checkbox } from '@bridebook/aura';
import { isEqual } from 'lodash';
import { memo } from 'react';
import { EmailButton } from './email-button';

interface IProps {
  items: {
    label: string;
    id: string;
    email: string;
    isSelected: boolean;
  }[];
  onSelect: (guestId: string, selected: boolean) => void;
  onEmailClick: (guestId: string) => void;
}

const _TeamCheckboxes = ({ items, onSelect, onEmailClick }: IProps) => (
  <div className="px-2">
    <div className="relative flex flex-col gap-4">
      {items.map((item, index) => (
        <div key={item.id} className="z-1 flex items-center gap-3">
          <div className="size-[24px]">
            <Checkbox
              checked={item.isSelected}
              id={item.id}
              onCheckedChange={(checked) => onSelect(item.id, !!checked)}
              disabled={!item.email}
            />
          </div>
          <div className="flex flex-col text-space-75">
            <label className="text-base font-normal" htmlFor={item.id}>
              {item.label}
            </label>
            <EmailButton
              guestId={item.id}
              email={item.email}
              isHead={index === 0}
              headEmail={items[0]?.email}
              onClick={onEmailClick}
            />
          </div>
        </div>
      ))}
      {/* TEAM WRAPPER BORDER */}
      {items.length > 1 && (
        <div className="absolute top-0 bottom-0 left-[-6px] w-[36px] rounded-[8px] border border-space-40"></div>
      )}
    </div>
  </div>
);

export const TeamCheckboxes = memo(_TeamCheckboxes, (prevProps, nextProps) =>
  isEqual(prevProps.items, nextProps.items),
);
